import React, { useEffect } from 'react';
import './CyberSmart.css';
import usePageTitle from '../hooks/usePageTitle';
import borderImage from '../assets/border.png';
import cybersmart1 from '../assets/cybersmart1.png';
import cybersmart2 from '../assets/cybersmart2.png';

const CyberSmart: React.FC = () => {
  usePageTitle('CyberSmart');
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const allElements = document.querySelectorAll('.cybersmart-title, .cybersmart-subtitle, .cybersmart-description, .cybersmart-paragraph');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });
    
    // Force reflow to ensure the removal is processed
    void document.body.offsetHeight;
    
    // Animate initial content on page load
    const titleElement = document.querySelector('.cybersmart-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Subtitle animates after title
    const subtitleElements = document.querySelectorAll('.cybersmart-subtitle');
    setTimeout(() => {
      subtitleElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 210);
    
    // Paragraphs animate 200ms after subtitle
    const paragraphElements = document.querySelectorAll('.cybersmart-description, .cybersmart-paragraph');
    setTimeout(() => {
      paragraphElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 410);
  }, []);

  return (
    <div className="cybersmart-page">
      <div className="cybersmart-container">
        <h1 className="cybersmart-title">CyberSmart Now Non-Profit</h1>
        <h2 className="cybersmart-subtitle">Published Author & Cybersecurity Educator</h2>
        <img src={borderImage} alt="" className="cybersmart-border-image" />
        
        <div className="cybersmart-content">
          <div className="cybersmart-images-section">
            <div className="cybersmart-images-container">
              <img src={cybersmart1} alt="CyberSmart Book Cover" className="cybersmart-image cybersmart-image-left" />
              <img src={cybersmart2} alt="CyberSmart Book Page" className="cybersmart-image cybersmart-image-right" />
            </div>
          </div>
          
          <div className="cybersmart-decorative-line"></div>
          
          <div className="cybersmart-text">
            <p className="cybersmart-description">
              Co-authored and published "Cyber Smarts for Students" on Amazon, addressing critical cybersecurity challenges 
              facing today's digital generation. Drawing from research experience and National CyberPatriot Competition 
              expertise, the publication provides comprehensive guidance on internet privacy, data protection, and digital 
              citizenship for student audiences. Extended impact through community outreach by delivering cybersecurity 
              education talks at local middle school assemblies across the Virginia area, translating complex technical concepts 
              into accessible presentations for younger students.
            </p>
            
            <p className="cybersmart-paragraph">
              Computer Science | Admission to Harvard
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CyberSmart;